import { faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import GooglePlayButton from '../Buttons/GooglePlay';
import AppleStoreButton from '../Buttons/AppleStore';
import './style.css';

export default function Footer() {
    return (
        <footer className="footer">
            <div className="footer-content">

                {/* TEXTO E CONTATOS */}
                <div className="footer-info">
                    <h4>A FUNEMG prepara você para o mercado de trabalho.</h4>

                    <p>
                        <FontAwesomeIcon icon={faPhone} />
                        <span>31 9609-2454</span>
                    </p>

                    <p>
                        <FontAwesomeIcon icon={faEnvelope} />
                        <span>contato@funemg.com.br</span>
                    </p>
                </div>

                {/* BOTÕES DAS LOJAS */}
                <div className="footer-apps">
                    <GooglePlayButton />
                    <AppleStoreButton />
                </div>
            </div>

            {/* LINHA */}
            <div className="footer-divider"></div>

            {/* COPYRIGHT */}
            <p className="footer-copy">
                © Todos os direitos reservados - FUNEMG
            </p>
        </footer>
    );
}
